import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { heroImages, whyUs, stats } from "../../mock";
import Reveal from "../Reveal";

export default function AboutSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-14 lg:grid-cols-2 items-center">
          {/* Image */}
          <Reveal>
            <div className="relative">
              <img
                src={heroImages.handshake}
                alt="LTR Capital Partners handshake"
                className="rounded-2xl shadow-2xl w-full object-cover aspect-[4/3]"
              />
              <div className="absolute -bottom-8 -right-4 sm:right-8 bg-[#0b1f3a] text-white rounded-2xl p-6 shadow-xl w-52">
                <div className="font-display text-4xl font-extrabold text-[#c6a15b]">72 hrs</div>
                <div className="text-sm text-slate-300 mt-1">or less to get funded once approved</div>
              </div>
            </div>
          </Reveal>

          {/* Content */}
          <Reveal delay={120}>
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c6a15b]">Why Choose Us</p>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0b1f3a] mt-3">
              LTR Capital Partners
            </h2>
            <p className="mt-5 text-slate-600 leading-relaxed">
              We provide commercial real estate finance for investment properties as well as funding
              to small, medium and large businesses. As one of the premier mortgage service providers
              in the United States, we offer financing for all kinds of investment properties —
              commercial, industrial, multi-family, mixed-use and more.
            </p>
            <p className="mt-4 text-slate-600 leading-relaxed">
              Our unique approach allows us to close quickly and securely on real estate investments,
              even when conventional lenders turn you away.
            </p>

            <div className="mt-8 space-y-5">
              {whyUs.map((w) => (
                <div key={w.title} className="flex gap-4">
                  <div className="h-7 w-7 rounded-full bg-[#c6a15b]/15 flex items-center justify-center shrink-0 mt-0.5">
                    <Check className="h-4 w-4 text-[#b08e46]" />
                  </div>
                  <div>
                    <div className="font-display font-bold text-[#0b1f3a]">{w.title}</div>
                    <div className="text-sm text-slate-600">{w.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="mt-9 inline-flex items-center gap-2 rounded-md bg-[#c6a15b] px-6 py-3 font-bold text-[#0b1f3a] hover:bg-[#d8bc85] transition-colors"
            >
              Learn More About Us
              <ArrowRight className="h-5 w-5" />
            </Link>
          </Reveal>
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 90}>
              <div className="rounded-2xl bg-slate-50 ring-1 ring-slate-100 p-8 text-center">
                <div className="font-display text-4xl font-extrabold text-[#0b1f3a]">{s.value}</div>
                <div className="mt-2 text-sm text-slate-500 font-medium">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
